import { formatDate } from '../../lib/date-helpers.ts';
import { useLocale } from '../../lib/hooks/use-locale.ts';

type DateTimeTextProps = {
    date?: string | number | Date | null;
    format?: Intl.DateTimeFormatOptions;
    children?: string | number | Date | null;
};

export const DateTimeText = ({
    date,
    children,
    format = {
        dateStyle: 'medium',
        timeStyle: 'medium',
    },
}: DateTimeTextProps) => {
    const { locale } = useLocale();
    const dateValue = date ?? children;

    if (!dateValue) {
        console.warn('DateTimeText: No date value provided');
        return null;
    }

    const newDate = new Date(dateValue);
    const formattedDate = newDate.toLocaleString(locale, format);

    return <span>{formattedDate}</span>;
};

export const DateText = ({
    date,
    children,
    format = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    },
}: DateTimeTextProps) => {
    const { locale } = useLocale();
    const dateValue = date ?? children;

    if (!dateValue) {
        console.warn('DateText: No date value provided');
        return null;
    }

    const formattedDate = formatDate(dateValue, locale, format);

    return <span>{formattedDate}</span>;
};

export const TimeText = ({
    date,
    children,
    format = {
        timeStyle: 'medium',
    },
}: DateTimeTextProps) => {
    const { locale } = useLocale();
    const dateValue = date ?? children;

    if (!dateValue) {
        console.warn('TimeText: No date value provided');
        return null;
    }

    const newDate = new Date(dateValue);
    const formattedDate = newDate.toLocaleTimeString(locale, format);

    return <span>{formattedDate}</span>;
};
